import axios from 'axios';

import { IEmployeeAbsenceType } from '@/shared/model/employee-absence-type.model';

const baseApiUrl = 'api/employee-absence-types';

export default class EmployeeAbsenceTypeService {
  public find(id: string): Promise<IEmployeeAbsenceType> {
    return new Promise<IEmployeeAbsenceType>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IEmployeeAbsenceType): Promise<IEmployeeAbsenceType> {
    return new Promise<IEmployeeAbsenceType>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IEmployeeAbsenceType): Promise<IEmployeeAbsenceType> {
    return new Promise<IEmployeeAbsenceType>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.code}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IEmployeeAbsenceType): Promise<IEmployeeAbsenceType> {
    return new Promise<IEmployeeAbsenceType>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.code}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
